var _g;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgCheckOutlineIc = function SvgCheckOutlineIc(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#373737"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.667 8.445L7.66 10l3.006-4"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#373737",
    fillRule: "nonzero",
    d: "M5.872 8.182a.333.333 0 0 0-.41.526l1.994 1.555c.148.115.36.086.472-.063l3.005-4a.333.333 0 0 0-.533-.4L7.6 9.529 5.872 8.182zM8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm0-.667A7.333 7.333 0 1 1 8 .667a7.333 7.333 0 0 1 0 14.666z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckOutlineIc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check_outline_ic.5dbd97fd.svg";
export { ForwardRef as ReactComponent };